/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Currency } from './';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './';
import type { QuoteScopeComputedValuesResource } from './';
import {
    QuoteScopeComputedValuesResourceFromJSON,
    QuoteScopeComputedValuesResourceFromJSONTyped,
    QuoteScopeComputedValuesResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface QuoteAmountSummaryResource
 */
export interface QuoteAmountSummaryResource {
    /**
     * 
     * @type {QuoteScopeComputedValuesResource}
     * @memberof QuoteAmountSummaryResource
     */
    computedValues: QuoteScopeComputedValuesResource;
    /**
     * 
     * @type {Currency}
     * @memberof QuoteAmountSummaryResource
     */
    freelancerCurrency: Currency;
    /**
     * 
     * @type {Currency}
     * @memberof QuoteAmountSummaryResource
     */
    clientCurrency: Currency;
}

/**
 * Check if a given object implements the QuoteAmountSummaryResource interface.
 */
export function instanceOfQuoteAmountSummaryResource(value: object): value is QuoteAmountSummaryResource {
    if (!('computedValues' in value) || value['computedValues'] === undefined) return false;
    if (!('freelancerCurrency' in value) || value['freelancerCurrency'] === undefined) return false;
    if (!('clientCurrency' in value) || value['clientCurrency'] === undefined) return false;
    return true;
}

export function QuoteAmountSummaryResourceFromJSON(json: any): QuoteAmountSummaryResource {
    return QuoteAmountSummaryResourceFromJSONTyped(json, false);
}

export function QuoteAmountSummaryResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuoteAmountSummaryResource {
    if (json == null) {
        return json;
    }
    return {
        
        'computedValues': QuoteScopeComputedValuesResourceFromJSON(json['computedValues']),
        'freelancerCurrency': CurrencyFromJSON(json['freelancerCurrency']),
        'clientCurrency': CurrencyFromJSON(json['clientCurrency']),
    };
}

export function QuoteAmountSummaryResourceToJSON(value?: QuoteAmountSummaryResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'computedValues': QuoteScopeComputedValuesResourceToJSON(value['computedValues']),
        'freelancerCurrency': CurrencyToJSON(value['freelancerCurrency']),
        'clientCurrency': CurrencyToJSON(value['clientCurrency']),
    };
}

